import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';

import { CissNumberField } from 'components/fields';
import { Row } from 'components/form';
import { Block } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { Revendedor } from 'pages/revendedor/revendedor/types';

export function RevendedorDiscountBlock() {
    const { values, errors, setFieldValue } = useFormikContext<Revendedor>();
    const { hasPermission } = usePermissionsContext();
    const disabled = !hasPermission(['REVENDEDOR_CADASTRO_CONFIGURACOES']);

    return (
        <Block>
            <Row sx={{ mb: 0 }}>
                <Grid sx={{ flex: 1 }}>
                    <CissNumberField
                        label="Valor mínimo do desconto"
                        name="vlMinimoDesconto"
                        inputType="decimal"
                        disabled={disabled}
                        preventEmptyField={false}
                        value={values.vlMinimoDesconto}
                        error={errors.vlMinimoDesconto}
                        onChange={(e) => setFieldValue('vlMinimoDesconto', Number(e.target.value))}
                    />
                </Grid>

                <Grid sx={{ flex: 1 }}>
                    <CissNumberField
                        label="Percentual de desconto"
                        name="peDesconto"
                        inputType="decimal"
                        forceMaxValue
                        maxValue={100}
                        disabled={disabled}
                        preventEmptyField={false}
                        value={values.peDesconto}
                        error={errors.peDesconto}
                        onChange={(e) => setFieldValue('peDesconto', Number(e.target.value))}
                    />
                </Grid>
            </Row>
        </Block>
    );
}
